import { render, staticRenderFns } from "./PhotoAdd.vue?vue&type=template&id=0fd64c29&"
import script from "./PhotoAdd.vue?vue&type=script&lang=js&"
export * from "./PhotoAdd.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports